export const video = {
    'video/3gpp': {
        extensions: ['3gp', '3gpp'],
        source: 'iana',
    },
    'video/3gpp2': {
        extensions: ['3g2'],
        source: 'iana',
    },
    'video/h261': {
        extensions: ['h261'],
        source: 'iana',
    },
    'video/h263': {
        extensions: ['h263'],
        source: 'iana',
    },
    'video/h264': {
        extensions: ['h264'],
        source: 'iana',
    },
    'video/iso.segment': {
        extensions: ['m4s'],
        source: 'iana',
    },
    'video/jpeg': {
        extensions: ['jpgv'],
        source: 'iana',
    },
    'video/jpm': {
        extensions: ['jpm', 'jpgm'],
        source: 'apache',
    },
    'video/mj2': {
        extensions: ['mj2', 'mjp2'],
        source: 'iana',
    },
    'video/mp2t': {
        extensions: ['ts'],
        source: 'iana',
    },
    'video/mp4': {
        extensions: ['mp4', 'mp4v', 'mpg4'],
        source: 'iana',
    },
    'video/mpeg': {
        extensions: ['mpeg', 'mpg', 'mpe', 'm1v', 'm2v'],
        source: 'iana',
    },
    'video/ogg': {
        extensions: ['ogv'],
        source: 'iana',
    },
    'video/quicktime': {
        extensions: ['qt', 'mov'],
        source: 'iana',
    },
    'video/vnd.dece.hd': {
        extensions: ['uvh', 'uvvh'],
        source: 'iana',
    },
    'video/vnd.dece.mobile': {
        extensions: ['uvm', 'uvvm'],
        source: 'iana',
    },
    'video/vnd.dece.pd': {
        extensions: ['uvp', 'uvvp'],
        source: 'iana',
    },
    'video/vnd.dece.sd': {
        extensions: ['uvs', 'uvvs'],
        source: 'iana',
    },
    'video/vnd.dece.video': {
        extensions: ['uvv', 'uvvv'],
        source: 'iana',
    },
    'video/vnd.dvb.file': {
        extensions: ['dvb'],
        source: 'iana',
    },
    'video/vnd.fvt': {
        extensions: ['fvt'],
        source: 'iana',
    },
    'video/vnd.mpegurl': {
        extensions: ['mxu', 'm4u'],
        source: 'iana',
    },
    'video/vnd.ms-playready.media.pyv': {
        extensions: ['pyv'],
        source: 'iana',
    },
    'video/vnd.uvvu.mp4': {
        extensions: ['uvu', 'uvvu'],
        source: 'iana',
    },
    'video/vnd.vivo': {
        extensions: ['viv'],
        source: 'iana',
    },
    'video/webm': {
        extensions: ['webm'],
        source: 'apache',
    },
    'video/x-f4v': {
        extensions: ['f4v'],
        source: 'apache',
    },
    'video/x-fli': {
        extensions: ['fli'],
        source: 'apache',
    },
    'video/x-flv': {
        extensions: ['flv'],
        source: 'apache',
    },
    'video/x-m4v': {
        extensions: ['m4v'],
        source: 'apache',
    },
    'video/x-matroska': {
        extensions: ['mkv', 'mk3d', 'mks'],
        source: 'apache',
    },
    'video/x-mng': {
        extensions: ['mng'],
        source: 'apache',
    },
    'video/x-ms-asf': {
        extensions: ['asf', 'asx'],
        source: 'apache',
    },
    'video/x-ms-vob': {
        extensions: ['vob'],
        source: 'apache',
    },
    'video/x-ms-wm': {
        extensions: ['wm'],
        source: 'apache',
    },
    'video/x-ms-wmv': {
        extensions: ['wmv'],
        source: 'apache',
    },
    'video/x-ms-wmx': {
        extensions: ['wmx'],
        source: 'apache',
    },
    'video/x-ms-wvx': {
        extensions: ['wvx'],
        source: 'apache',
    },
    'video/x-msvideo': {
        extensions: ['avi'],
        source: 'apache',
    },
    'video/x-sgi-movie': {
        extensions: ['movie'],
        source: 'apache',
    },
    'video/x-smv': {
        extensions: ['smv'],
        source: 'apache',
    },
} as const;
